import { useLocales } from '@shared/locales'
import { Button, Flex } from 'antd'
import { Add } from 'iconsax-react'
import { useState } from 'react'

import { AddCampaign } from './AddCampaign'

export const CampaignHeader = () => {
  const { t } = useLocales()
  const [isOpen, setIsOpen] = useState(false)

  const onToggle = () => setIsOpen((prev) => !prev)

  return (
    <Flex justify="flex-end">
      <Button onClick={onToggle} icon={<Add size={16} />} type="primary">
        {t('campaigns.add_campaign')}
      </Button>

      {isOpen && <AddCampaign open onCancel={onToggle} />}
    </Flex>
  )
}
